import { type RouteObject } from 'react-router';

import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        lazy: async () => {
            const { Sitemap } = await import('@@routes/sitemap');

            return { Component: Sitemap };
        },
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: null },
            {
                path: ':tenantId',
                lazy: async () => {
                    const { SitemapTenant } = await import('@@routes/sitemap');

                    return { Component: SitemapTenant };
                },
                children: [
                    { index: true, element: null },
                    {
                        path: 'nodes/:sitemapNodeId',
                        lazy: async () => {
                            const { SitemapNodeModal } = await import('@@routes/sitemap');

                            return { Component: SitemapNodeModal };
                        },
                        errorElement: <ErrorPage />,
                    },
                ],
            },
        ],
    },
];
